const InputField = ({ label, value, onChange, type = "text" }) => {
  return (
    <div className="form-group">
      <label>{label}</label>
      <input
        type={type}
        value={value}
        onChange={onChange}
        className="form-control"
        style={{width:"200px"}}
      />
    </div>
  );
};

export default InputField;